import React from 'react';
import { memo } from "react";
const StepperLeftArrowIcon = () => {
    return (React.createElement("svg", { width: "6", height: "10", viewBox: "0 0 6 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M5.77875 8.4425L2.34375 5L5.77875 1.5575L4.72125 0.5L0.221252 5L4.72125 9.5L5.77875 8.4425Z", fill: "#363948" })));
};
export default memo(StepperLeftArrowIcon);
